<template>
  <!-- 是否送礼 -->
  <el-dialog
    top="30vh"
    title=""
    :visible.sync="visible"
    class="first-gift-dialog"
    :close-on-click-modal="true"
  >
    <div class="first-gift">
      <div class="row1">
        {{ $t("gifr.send") }}
        <span>{{ giftNumber }} x {{ gift.title }}</span>
        {{ $t("gift.to") }}
      </div>
      <div class="row2" @click="toggleFastSendGift">
        <img v-show="!isSelect" src="@/assets/img/dialog/select.png" alt="" />
        <img v-show="isSelect" src="@/assets/img/dialog/select-1.png" alt="" />
        <div>{{ $t("gift.ignore_next") }}</div>
      </div>
      <div class="row3">
        <div class="btn" @click="visible = false">
          {{ $t("user.cancelText") }}
        </div>
        <div class="btn btn-active" @click="confirm">
          {{ $t("user.modalConfirmText") }}
        </div>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapState, mapMutations, mapActions } from "vuex";
import { post } from "../../util/http";
export default {
  computed: {
    ...mapState(["userInfo", "appConfig"]),
  },
  props: {
    giftNumber: {
      type: Number,
      default() {
        return 0;
      },
    },
    gift: {
      type: Object,
      default() {
        return {};
      },
    },
  },

  data() {
    return {
      visible: false,
      isSelect: false,
    };
  },
  created() {},
  destroyed() {},
  mounted() {},
  methods: {
    toggleFastSendGift() {
      this.isSelect = !this.isSelect;
    },
    open() {
      this.visible = true;
    },
    confirm() {
      this.$emit("sendGiftReal");
      this.visible = false;
      localStorage.setItem("isFastSendGift", this.isSelect);
    },
  },
};
</script>

<style scoped lang="scss">
::v-deep {
  .el-dialog__header {
    display: none;
  }
  .el-dialog__body {
    padding: 0;
    // height: 5.74rem;
  }
  .el-dialog {
    width: 3.55rem;
    height: 1.96rem;
    border-radius: 0.1rem;
  }
}
.first-gift {
  height: 1.96rem;
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;
  padding: 0.2rem 0;
  .row1 {
    color: #333333;
    font-size: 0.18rem;
    span {
      color: rgba(208, 45, 84, 1);
    }
  }
  .row2 {
    display: flex;
    align-items: center;
    justify-content: center;
    color: #666666;
    font-size: 0.15rem;
    cursor: pointer;
    img {
      width: 0.16rem;
      height: 0.16rem;
      margin-right: 0.05rem;
    }
  }
  .row3 {
    display: flex;
    align-items: center;
    justify-content: center;
    .btn {
      width: 1.12rem;
      height: 0.34rem;
      display: flex;
      align-items: center;
      justify-content: center;
      color: #666666;
      font-size: 0.16rem;
      color: rgba(208, 45, 84, 1);
      border: 1px solid rgba(208, 45, 84, 1);
      border-radius: 1rem;
      cursor: pointer;
    }
    .btn-active {
      background: rgba(208, 45, 84, 1);
      color: #ffffff;
      margin-left: 0.24rem;
    }
  }
}
</style>
